.wrapper {
  --list-item-gap: 16px;
  --list-item-padding-block: 12px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--color-border-primary);
  }

  &:has(input:disabled) {
    color: var(--color-text-secondary);
  }
}
